import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

class ThePlatformSolution extends Component {
	componentDidMount() {
		document.getElementById('root').classList.remove('welcome');
		document.getElementById("root").classList.remove("affiliate");
		document.getElementById('foo').classList.add('overflow');
	}
	render() {
		return (
			<div className="sub-page product">
				<Helmet>
					<title>STech - Powerful Products &amp; Partners</title>
					<meta name="description" content="STech - Powerful Products &amp; Partners" />
				</Helmet>
				<header className="clearfix fadeInUp">
					<div className="container">
						<div className="left"></div>
						<div className="right">
							<h1>Powerful Products &amp; Partners</h1>
							<h2>Products</h2>
						</div>
					</div>
				</header>
				<section className="clearfix fadeInUp">
					<div className="container partners">
						<div className="left"></div>
						<div className="right">
							<div className="content">
								Quality is one of the major cornerstones for us at STech Technology. We live and breathe this motto and it also reflects our carefully chosen products and partners. <br /><br />
								STech only works with the best possible tools and products in the iGaming industry, from sportsbook and casino games providers, to payment agents
								and KYC solutions.
							</div>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp contact">
					<div className="container">
						<h2>We grow together</h2>
						<div className="content">
							<p>STech is a hi-tech, fast-paced company but above all we aim to create business partnerships that grow over time.</p>
							<Link to="/contact">
								Contact Us
							</Link>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default ThePlatformSolution
